import React from 'react';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';

const ModuleLoader = ({height}) => {
  const heightVal = height || 200;
  return <LoaderSkelton height={`${heightVal}px`} />;
};

export default ModuleLoader;
